/* NatOnat section controllers. No third-party dependencies. */
(function () {
'use strict';
var initializers = Object.create(null);
initializers['nt-spot'] = function(root) {
  
  if (!root) return;
  var track =
    root.querySelector(
      '.nt-spot__track'
    );
  var belt =
    root.querySelector(
      '.nt-spot__belt-lines'
    );
  if (
    'IntersectionObserver'
    in window
  ) {
    var observer =
      new IntersectionObserver(
        function (entries) {
          entries.forEach(
            function (entry) {
              var state =
                entry.isIntersecting
                ? 'running'
                : 'paused';
              if (track) {
                track.style.animationPlayState =
                  state;
              }
              if (belt) {
                belt.style.animationPlayState =
                  state;
              }
            }
          );
        },
        {
          threshold:
            .05
        }
      );
    observer.observe(root);
  }

};
initializers['nt-size'] = function(root) {
  
  if (!root) return;
  var input =
    root.querySelector(
      '.nt-size__input'
    );
  var inputUnit =
    root.querySelector(
      '.nt-size__input-unit'
    );
  var unitButtons =
    root.querySelectorAll(
      '.nt-size__unit'
    );
  var findButton =
    root.querySelector(
      '.nt-size__find'
    );
  var empty =
    root.querySelector(
      '.nt-size__empty'
    );
  var result =
    root.querySelector(
      '.nt-size__result'
    );
  var warning =
    root.querySelector(
      '.nt-size__warning'
    );
  var resultLetter =
    root.querySelector(
      '.nt-size__result-letter'
    );
  var resultName =
    root.querySelector(
      '.nt-size__result-name'
    );
  var resultRange =
    root.querySelector(
      '.nt-size__result-range'
    );
  var resultInch =
    root.querySelector(
      '.nt-size__result-inch'
    );
  var enteredValue =
    root.querySelector(
      '.nt-size__entered-value'
    );
  var shopText =
    root.querySelector(
      '.nt-size__shop-text'
    );
  var sizeCards =
    root.querySelectorAll(
      '.nt-size-card'
    );
  var currentUnit =
    'cm';
  /*
    OFFICIAL NATONAT SIZE RANGES
    Height only.
    Wheels excluded.
  */
  var sizes = [
    {
      size: 'S',
      name: 'Carry-on',
      minCm: 45,
      maxCm: 53,
      cm: '45–53 CM',
      inch: '18–21 Inches'
    },
    {
      size: 'M',
      name: 'Medium',
      minCm: 55,
      maxCm: 63,
      cm: '55–63 CM',
      inch: '22–25 Inches'
    },
    {
      size: 'L',
      name: 'Large',
      minCm: 65,
      maxCm: 70,
      cm: '65–70 CM',
      inch: '26–28 Inches'
    },
    {
      size: 'XL',
      name: 'Extra Large',
      minCm: 72,
      maxCm: 81,
      cm: '72–81 CM',
      inch: '29–32 Inches'
    }
  ];
  function hideStates() {
    empty.style.display =
      'none';
    result.classList.remove(
      'show'
    );
    warning.classList.remove(
      'show'
    );
  }
  function resetState() {
    delete root.dataset.matchedSize;
    sizeCards.forEach(function(card) { card.classList.remove('is-matched'); });
    result.classList.remove(
      'show'
    );
    warning.classList.remove(
      'show'
    );
    empty.style.display =
      'flex';
  }
  function findSize(value) {
    if (
      value === '' ||
      value === null ||
      isNaN(value)
    ) {
      resetState();
      return;
    }
    var rawValue =
      parseFloat(value);
    if (
      !rawValue ||
      rawValue <= 0
    ) {
      resetState();
      return;
    }
    var cmValue =
      currentUnit === 'in'
      ? rawValue * 2.54
      : rawValue;
    var match =
      null;
    for (
      var i = 0;
      i < sizes.length;
      i++
    ) {
      if (
        cmValue >= sizes[i].minCm &&
        cmValue <= sizes[i].maxCm
      ) {
        match =
          sizes[i];
        break;
      }
    }
    hideStates();
    if (!match) {
      delete root.dataset.matchedSize;
      sizeCards.forEach(function(card) { card.classList.remove('is-matched'); });
      warning.classList.add(
        'show'
      );
      return;
    }
    resultLetter.textContent =
      match.size;
    resultName.textContent =
      match.name;
    resultRange.textContent =
      match.cm;
    resultInch.textContent =
      match.inch;
    enteredValue.textContent =
      rawValue.toFixed(
        rawValue % 1 === 0
        ? 0
        : 1
      )
      +
      ' '
      +
      (
        currentUnit === 'cm'
        ? 'CM'
        : 'IN'
      );
    root.dataset.matchedSize = match.size;
    sizeCards.forEach(function(card) {
      var height = Number(card.getAttribute('data-demo-cm'));
      card.classList.toggle('is-matched', height >= match.minCm && height <= match.maxCm);
    });
    shopText.textContent = 'EXPLORE LUGGAGE COVERS';
    result.classList.add(
      'show'
    );
  }
  /*
    UNIT SWITCH
  */
  unitButtons.forEach(
    function (button) {
      button.addEventListener(
        'click',
        function () {
          var newUnit =
            this.getAttribute(
              'data-unit'
            );
          if (
            newUnit === currentUnit
          ) {
            return;
          }
          var currentValue =
            parseFloat(
              input.value
            );
          if (
            !isNaN(currentValue)
          ) {
            if (
              currentUnit === 'cm' &&
              newUnit === 'in'
            ) {
              input.value =
                (
                  currentValue /
                  2.54
                )
                .toFixed(1);
            }
            else if (
              currentUnit === 'in' &&
              newUnit === 'cm'
            ) {
              input.value =
                (
                  currentValue *
                  2.54
                )
                .toFixed(1);
            }
          }
          currentUnit =
            newUnit;
          unitButtons.forEach(
            function (unitButton) {
              unitButton.classList.remove(
                'active'
              );
            }
          );
          this.classList.add(
            'active'
          );
          inputUnit.textContent =
            currentUnit === 'cm'
            ? 'CM'
            : 'IN';
          input.placeholder =
            currentUnit === 'cm'
            ? 'e.g. 60'
            : 'e.g. 24';
          if (input.value) {
            findSize(
              input.value
            );
          }
        }
      );
    }
  );
  /*
    FIND BUTTON
  */
  findButton.addEventListener(
    'click',
    function () {
      findSize(
        input.value
      );
    }
  );
  /*
    ENTER KEY
  */
  input.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Enter'
      ) {
        event.preventDefault();
        findSize(
          input.value
        );
      }
    }
  );
  /*
    LIVE UPDATE AFTER USER STARTS
  */
  input.addEventListener(
    'input',
    function () {
      if (
        input.value === ''
      ) {
        resetState();
        return;
      }
      findSize(
        input.value
      );
    }
  );
  /*
    QUICK SIZE CARDS
    Clicking one demonstrates
    the middle of that size range.
  */
  sizeCards.forEach(
    function (card) {
      card.addEventListener(
        'click',
        function () {
          var demoCm =
            parseFloat(
              this.getAttribute(
                'data-demo-cm'
              )
            );
          if (
            currentUnit === 'cm'
          ) {
            input.value =
              demoCm;
          }
          else {
            input.value =
              (
                demoCm /
                2.54
              )
              .toFixed(1);
          }
          findSize(
            input.value
          );
          var finder =
            root.querySelector(
              '.nt-size__finder'
            );
          if (
            window.innerWidth < 750
          ) {
            finder.scrollIntoView(
              {
                behavior: 'smooth',
                block: 'center'
              }
            );
          }
        }
      );
    }
  );

};
initializers['nt-style'] = function(root) {
  
  if (!root) return;
  // One featured design and a compact, coordinated list; keep the actual product nodes.
  var products = root.querySelector('.nt-style__products');
  var editorial = document.createElement('div');
  editorial.className = 'nat-style-editorial';
  var feature = document.createElement('div');
  feature.className = 'nat-style-feature';
  var selection = document.createElement('div');
  selection.className = 'nat-style-selection';
  products.before(editorial);
  editorial.append(feature, selection);
  selection.append(root.querySelector('.nt-style__active-head'), products, root.querySelector('.nt-style__footer'));
  root.classList.add('is-editorial');
  var tabs =
    root.querySelectorAll(
      '.nt-style__tab'
    );
  var cards =
    root.querySelectorAll(
      '.nt-style-card'
    );
  var activeTitle =
    root.querySelector(
      '.nt-style__active-title'
    );
  var activeCopy =
    root.querySelector(
      '.nt-style__active-copy'
    );
  var count =
    root.querySelector(
      '.nt-style__count'
    );
  var empty =
    root.querySelector(
      '.nt-style__empty'
    );
  /*
    Maximum products shown per style.
    One featured design and up to three alternatives.
  */
  var limit =
    4;
  function activateStyle(
    style,
    title,
    copy
  ) {
    var shown =
      0;
    cards.forEach(function(card) { products.appendChild(card); card.classList.remove('is-featured'); });
    cards.forEach(
      function (card) {
        var styles =
          card
          .getAttribute(
            'data-style'
          )
          || '';
        var matches =
          styles
          .split(' ')
          .indexOf(style)
          !== -1;
        if (
          matches &&
          shown < limit
        ) {
          card.classList.remove(
            'is-hidden'
          );
          if (shown === 0) {
            card.classList.add('is-featured');
            feature.appendChild(card);
            var label = card.querySelector('.nat-style-feature-title');
            if (!label) { label = document.createElement('span'); label.className = 'nat-style-feature-title'; card.querySelector('.nt-style-card__info').prepend(label); }
            label.textContent = title;
          }
          shown++;
        }
        else {
          card.classList.add(
            'is-hidden'
          );
        }
      }
    );
    activeTitle.textContent =
      title;
    activeCopy.textContent =
      copy;
    feature.hidden = shown === 0;
    editorial.classList.toggle('is-empty', shown === 0);
    count.textContent =
      shown;
    if (shown === 0) {
      empty.classList.add(
        'show'
      );
    }
    else {
      empty.classList.remove(
        'show'
      );
    }
  }
  tabs.forEach(function(tab, index) {
    tab.addEventListener('keydown', function(event) {
      var next;
      if(event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if(event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      else if(event.key === 'Home') next = 0;
      else if(event.key === 'End') next = tabs.length - 1;
      if(next !== undefined) { event.preventDefault(); tabs[next].focus(); tabs[next].click(); }
    });
  });
  tabs.forEach(
    function (tab) {
      tab.addEventListener(
        'click',
        function () {
          tabs.forEach(
            function (item) {
              item.classList.remove(
                'is-active'
              );
              item.setAttribute(
                'aria-selected',
                'false'
              );
            }
          );
          tab.classList.add(
            'is-active'
          );
          tab.setAttribute(
            'aria-selected',
            'true'
          );
          activateStyle(
            tab.getAttribute(
              'data-style'
            ),
            tab.getAttribute(
              'data-title'
            ),
            tab.getAttribute(
              'data-copy'
            )
          );
        }
      );
    }
  );
  /*
    INITIAL STATE
  */
  var initial =
    root.querySelector(
      '.nt-style__tab.is-active'
    );
  if (initial) {
    activateStyle(
      initial.getAttribute(
        'data-style'
      ),
      initial.getAttribute(
        'data-title'
      ),
      initial.getAttribute(
        'data-copy'
      )
    );
  }

};
initializers['nt-transform'] = function(root) {
  
  if (!root) return;
  var stage =
    root.querySelector(
      '[data-transform-stage]'
    );
  var range =
    root.querySelector(
      '[data-range]'
    );
  var clip =
    root.querySelector(
      '[data-after-clip]'
    );
  var divider =
    root.querySelector(
      '[data-divider]'
    );
  if (
    !stage ||
    !range ||
    !clip ||
    !divider
  ) {
    return;
  }
  function updateSlider() {
    var value =
      parseFloat(
        range.value
      );
    clip.style.clipPath =
      'inset(0 0 0 '
      +
      value
      +
      '%)';
    divider.style.left =
      value
      +
      '%';
    if (
      value !== 50
    ) {
      stage.classList.add(
        'has-moved'
      );
    }
  }
  range.addEventListener(
    'input',
    updateSlider
  );
  range.addEventListener(
    'change',
    function () {
      stage.classList.add(
        'has-moved'
      );
    }
  );
  updateSlider();

};
initializers['nt-bundle'] = function(root) {
  
  if (!root) return;
  var cards =
    root.querySelectorAll(
      '[data-product-card]'
    );
  var checks =
    root.querySelectorAll(
      '.nt-bundle__check'
    );
  var variants =
    root.querySelectorAll(
      '.nt-bundle__variant'
    );
  var countEl =
    root.querySelector(
      '.nt-bundle__item-count'
    );
  var totalEl =
    root.querySelector(
      '.nt-bundle__total-price'
    );
  var summary =
    root.querySelector(
      '.nt-bundle__summary'
    );
  var progress =
    root.querySelector(
      '.nt-bundle__progress-fill'
    );
  var offerMessage =
    root.querySelector(
      '.nt-bundle__offer-message'
    );
  var addButton =
    root.querySelector(
      '.nt-bundle__add'
    );
  var addText =
    root.querySelector(
      '.nt-bundle__add-text'
    );
  var error =
    root.querySelector(
      '.nt-bundle__error'
    );
  var threshold =
    parseInt(
      summary.getAttribute(
        'data-threshold'
      ),
      10
    ) || 160000;
  /* ========================================================
     MONEY FORMAT
  ======================================================== */
  function formatMoney(cents) {
    var amount =
      cents / 100;
    return (
      'LE ' +
      new Intl.NumberFormat(
        'en-US',
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(amount)
    );
  }
  /* ========================================================
     GET CARD PRICE
  ======================================================== */
  function getVariantData(card) {
    var selector =
      card.querySelector(
        '.nt-bundle__variant'
      );
    if (!selector) {
      return null;
    }
    if (
      selector.tagName.toLowerCase()
      === 'select'
    ) {
      var option =
        selector.options[
          selector.selectedIndex
        ];
      if (!option) {
        return null;
      }
      return {
        id:
          parseInt(
            option.value,
            10
          ),
        price:
          parseInt(
            option.getAttribute(
              'data-price'
            ),
            10
          ) || 0
      };
    }
    return {
      id:
        parseInt(
          selector.value,
          10
        ),
      price:
        parseInt(
          selector.getAttribute(
            'data-price'
          ),
          10
        ) || 0
    };
  }
  /* ========================================================
     GET SELECTED
  ======================================================== */
  function getSelectedItems() {
    var items =
      [];
    cards.forEach(
      function (card) {
        var check =
          card.querySelector(
            '.nt-bundle__check'
          );
        if (
          !check ||
          !check.checked ||
          check.disabled
        ) {
          return;
        }
        var variant =
          getVariantData(card);
        if (
          !variant ||
          !variant.id
        ) {
          return;
        }
        items.push(
          variant
        );
      }
    );
    return items;
  }
  /* ========================================================
     UPDATE CARD VISUAL
  ======================================================== */
  function updateCards() {
    cards.forEach(
      function (card) {
        var check =
          card.querySelector(
            '.nt-bundle__check'
          );
        if (
          check &&
          check.checked &&
          !check.disabled
        ) {
          card.classList.add(
            'is-selected'
          );
        }
        else {
          card.classList.remove(
            'is-selected'
          );
        }
      }
    );
  }
  /* ========================================================
     UPDATE PRICE ON VARIANT CHANGE
  ======================================================== */
  function updateCardPrice(selector) {
    var card =
      selector.closest(
        '[data-product-card]'
      );
    if (!card) return;
    var priceEl =
      card.querySelector(
        '.nt-bundle__current-price'
      );
    if (!priceEl) return;
    var variant =
      getVariantData(card);
    if (!variant) return;
    priceEl.textContent =
      formatMoney(
        variant.price
      );
  }
  /* ========================================================
     UPDATE SUMMARY
  ======================================================== */
  function updateSummary() {
    updateCards();
    var items =
      getSelectedItems();
    var subtotal =
      0;
    items.forEach(
      function (item) {
        subtotal +=
          item.price;
      }
    );
    countEl.textContent =
      items.length;
    totalEl.textContent =
      formatMoney(
        subtotal
      );
    var percentage =
      threshold > 0
      ? (
          subtotal /
          threshold
        ) * 100
      : 100;
    percentage =
      Math.min(
        100,
        Math.max(
          0,
          percentage
        )
      );
    progress.style.width =
      percentage + '%';
    if (
      subtotal >= threshold
    ) {
      offerMessage.textContent =
        '✓ 5% OFF + FREE DELIVERY UNLOCKED';
    }
    else {
      var remaining =
        threshold -
        subtotal;
      offerMessage.textContent =
        formatMoney(
          remaining
        )
        +
        ' AWAY';
    }
    addButton.disabled =
      items.length === 0;
  }
  /* ========================================================
     CHECKBOX EVENTS
  ======================================================== */
  checks.forEach(
    function (check) {
      check.addEventListener(
        'change',
        updateSummary
      );
    }
  );
  /* ========================================================
     VARIANT EVENTS
  ======================================================== */
  variants.forEach(
    function (selector) {
      selector.addEventListener(
        'change',
        function () {
          updateCardPrice(
            selector
          );
          updateSummary();
        }
      );
    }
  );
  /* ========================================================
     ADD ALL SELECTED PRODUCTS
  ======================================================== */
  addButton.addEventListener(
    'click',
    function () {
      var selected =
        getSelectedItems();
      if (
        !selected.length
      ) {
        return;
      }
      error.textContent =
        '';
      addButton.disabled =
        true;
      addText.textContent =
        'ADDING TO CART...';
      var items =
        selected.map(
          function (item) {
            return {
              id:
                item.id,
              quantity:
                1
            };
          }
        );
      var cartUrl =
        (
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
        )
        ? window.Shopify.routes.root
          + 'cart/add.js'
        : '/cart/add.js';
      fetch(
        cartUrl,
        {
          method:
            'POST',
          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },
          body:
            JSON.stringify(
              {
                items:
                  items
              }
            )
        }
      )
      .then(
        function (response) {
          if (
            !response.ok
          ) {
            return response
              .json()
              .then(
                function (data) {
                  throw new Error(
                    data.description ||
                    data.message ||
                    'Unable to add products.'
                  );
                }
              );
          }
          return response.json();
        }
      )
      .then(
        function () {
          addText.textContent =
            'ADDED TO CART ✓';
          setTimeout(
            function () {
              window.location.href =
                (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            },
            650
          );
        }
      )
      .catch(
        function (err) {
          addButton.disabled =
            false;
          addText.textContent =
            'ADD SELECTED TO CART';
          error.textContent =
            err.message ||
            'Something went wrong. Please try again.';
        }
      );
    }
  );
  /* INITIAL */
  variants.forEach(
    function (selector) {
      updateCardPrice(
        selector
      );
    }
  );
  updateSummary();

};
initializers['nt-faq'] = function(root) {
  
  if (!root) return;
  var items =
    root.querySelectorAll(
      '[data-faq-item]'
    );
  var toggles =
    root.querySelectorAll(
      '[data-faq-toggle]'
    );
  var sizeButtons =
    root.querySelectorAll(
      '[data-find-size]'
    );
  /* ========================================================
     FAQ
  ======================================================== */
  toggles.forEach(
    function (toggle) {
      toggle.addEventListener(
        'click',
        function () {
          var item =
            toggle.closest(
              '[data-faq-item]'
            );
          if (!item) return;
          var opening =
            !item.classList.contains(
              'is-open'
            );
          /*
            CLOSE ALL
          */
          items.forEach(
            function (faq) {
              faq.classList.remove(
                'is-open'
              );
              var button =
                faq.querySelector(
                  '[data-faq-toggle]'
                );
              if (button) {
                button.setAttribute(
                  'aria-expanded',
                  'false'
                );
              }
            }
          );
          /*
            OPEN SELECTED
          */
          if (opening) {
            item.classList.add(
              'is-open'
            );
            toggle.setAttribute(
              'aria-expanded',
              'true'
            );
          }
        }
      );
    }
  );
  /* ========================================================
     FIND SIZE SECTION
  ======================================================== */
  sizeButtons.forEach(
    function (button) {
      button.addEventListener(
        'click',
        function () {
          /*
            Finds the interactive FIND YOUR SIZE
            section created earlier.
          */
          var sizeSection =
            document.querySelector(
              '[id^="nt-size-"]'
            );
          if (!sizeSection) {
            /*
              Fallback to luggage collection
              if the size finder is removed later.
            */
            window.location.href =
              root.dataset.collectionUrl;
            return;
          }
          sizeSection.scrollIntoView(
            {
              behavior:
                'smooth',
              block:
                'start'
            }
          );
          /*
            Focus the size input after scroll.
          */
          setTimeout(
            function () {
              var input =
                sizeSection.querySelector(
                  '.nt-size__input'
                );
              if (input) {
                input.focus(
                  {
                    preventScroll:
                      true
                  }
                );
              }
            },
            650
          );
        }
      );
    }
  );

};
function mount(scope) {
  Object.keys(initializers).forEach(function(name) {
    scope.querySelectorAll('.' + name).forEach(function(root) {
      if (root.dataset.natonatReady) return;
      initializers[name](root);
      root.dataset.natonatReady = 'true';
    });
  });
}
mount(document);
document.addEventListener('shopify:section:load', function(event) { mount(event.target); });
document.addEventListener('click', function(event) {
  var beltToggle = event.target.closest('[data-belt-toggle]');
  if (beltToggle) {
    var spot = beltToggle.closest('.nt-spot');
    var paused = spot.classList.toggle('is-paused');
    beltToggle.setAttribute('aria-pressed', String(paused));
    beltToggle.textContent = paused ? 'Play conveyor' : 'Pause conveyor';
    return;
  }
  var link = event.target.closest('[data-build-matched-set]');
  if (!link) return;
  var finder = link.closest('.nt-size');
  var bundle = document.querySelector('.nt-bundle');
  if (!finder || !bundle || !finder.dataset.matchedSize) return;
  var selector = bundle.querySelector('select.nt-bundle__variant');
  if (!selector) return;
  var aliases = {S:['s','small'],M:['m','medium'],L:['l','large'],XL:['xl','extra large']};
  var match = Array.from(selector.options).find(function(option) {
    return !option.disabled && aliases[finder.dataset.matchedSize].includes(option.textContent.trim().toLowerCase());
  });
  if (match) {
    selector.value = match.value;
    selector.dispatchEvent(new Event('change', {bubbles:true}));
  }
  var message = bundle.querySelector('.nt-bundle__error');
  if (message) message.textContent = match ? '' : 'Your recommended size is not available in this set. Please choose an available size or explore all luggage covers.';
});
})();
